import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { PartnerDetailPageContext, PartnerDetailPageInitialState } from ".";

export const PartnerDetailPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(PartnerDetailPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <PartnerDetailPageContext.Provider value={context}>
      {children}
    </PartnerDetailPageContext.Provider>
  );
};
